import { Link } from "gatsby";
import React from "react";

const ProgramEthics = ({ ethics, focuses }) => {
  const tabTitle = "Program ethics";
  const list =
    ethics
      ?.filter((ethicHasFocusArea) => !ethicHasFocusArea?.ethicsFocusArea)
      ?.map((genericEthic) => ({
        title: genericEthic.ethicsTitle,
        content: genericEthic.ethicsText,
        link: genericEthic.ethicsLink
      })) ?? [];

  const ethicsByFocus =
    ethics
      ?.filter((ethicWithFocus) => !!ethicWithFocus.ethicsFocusArea)
      ?.filter((ethicWithFocusDet) => {
        const matchedFocus = ethicWithFocusDet.ethicsFocusArea.filter(
          (focusArea) => {
            return focuses
              ?.map((programFocus) => programFocus.id)
              ?.includes(focusArea.id);
          }
        );
        return matchedFocus.length > 0 ? matchedFocus : false;
      })
      ?.map((ethicDetail) => ({
        title: ethicDetail.ethicsTitle,
        content: ethicDetail.ethicsText,
        link: ethicDetail.ethicsLink
      })) ?? [];

  const data = [...list, ...ethicsByFocus];

  return (
    <>
      <h2 className="heading py-5 text-left text-[26px] md:text-[2rem]">
        {tabTitle}
      </h2>
      <div className="divide-y width-divider" />

      <div className="pt-6">
        {data.map((item, index) => (
          <div key={index} className="pb-7">
            <h6
              className="!pb-1 w-full dark:text-white"
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
            <div
              className="dark:!text-gray-generic"
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
            {item.link && (
              <Link
                to={item.link}
                className="underline underline-offset-4 dark:text-white"
              >
                Learn more
              </Link>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default ProgramEthics;
